import { render, staticRenderFns } from "./MagazaSatis1.vue?vue&type=template&id=2f73764e&scoped=true&"
import script from "./MagazaSatis1.vue?vue&type=script&lang=js&"
export * from "./MagazaSatis1.vue?vue&type=script&lang=js&"
import style0 from "./MagazaSatis1.vue?vue&type=style&index=0&id=2f73764e&lang=scss&scoped=true&"
import style1 from "./MagazaSatis1.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f73764e",
  null
  
)

export default component.exports